<template>
    <div>
        <div class="one">
            <div class="form-floating w-100">
                <input  :type="actual_pass_eye == 2 ? 'text' : 'password'" 
                        class="form-control" id="floatingInput" placeholder="Tvoje aktuálne heslo" 
                        v-model="actual_pass" />
                <label for="floatingInput">{{ $t('account.zmenahesla_text_0') }}</label>
            </div>
            <i v-show="actual_pass_eye == 1" class="fa fa-eye ml-2" @click="actual_pass_eye = 2"></i>
            <i v-show="actual_pass_eye == 2" class="fa fa-eye-slash ml-2" @click="actual_pass_eye = 1"></i>
        </div> 
        <div class="one mt-3">
            <div class="form-floating w-100">
                <input  :type="new_pass_eye == 2 ? 'text' : 'password'" 
                        @focus="focus_password = true" 
                        @blur="focus_password = false"
                        class="form-control" id="floatingInput" placeholder="Nové heslo" 
                        v-model="new_pass" />
                <label for="floatingInput">{{ $t('account.zmenahesla_text_1') }}</label>
            </div>
            <i v-show="new_pass_eye == 1" class="fa fa-eye ml-2" @click="new_pass_eye = 2"></i>
            <i v-show="new_pass_eye == 2" class="fa fa-eye-slash ml-2" @click="new_pass_eye = 1"></i>
            <div v-if="focus_password" class="password_errors">
                <span :class="passowrd_errors.znaky ? 'active' : ''">
                    <svg v-if="!passowrd_errors.znaky" width="16" height="14" viewBox="0 0 16 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path fill-rule="evenodd" clip-rule="evenodd" d="M6.25709 1.099C7.02209 -0.260998 8.97909 -0.260998 9.74309 1.099L15.3231 11.019C16.0731 12.353 15.1101 13.999 13.5811 13.999H2.42009C0.890093 13.999 -0.0729075 12.353 0.677092 11.019L6.25709 1.099ZM9.00009 11C9.00009 11.2652 8.89474 11.5196 8.7072 11.7071C8.51966 11.8946 8.26531 12 8.00009 12C7.73488 12 7.48052 11.8946 7.29299 11.7071C7.10545 11.5196 7.00009 11.2652 7.00009 11C7.00009 10.7348 7.10545 10.4804 7.29299 10.2929C7.48052 10.1054 7.73488 10 8.00009 10C8.26531 10 8.51966 10.1054 8.7072 10.2929C8.89474 10.4804 9.00009 10.7348 9.00009 11ZM8.00009 3C7.73488 3 7.48052 3.10536 7.29299 3.2929C7.10545 3.48043 7.00009 3.73479 7.00009 4V7C7.00009 7.26522 7.10545 7.51957 7.29299 7.70711C7.48052 7.89465 7.73488 8 8.00009 8C8.26531 8 8.51966 7.89465 8.7072 7.70711C8.89474 7.51957 9.00009 7.26522 9.00009 7V4C9.00009 3.73479 8.89474 3.48043 8.7072 3.2929C8.51966 3.10536 8.26531 3 8.00009 3Z" fill="#E83C58"/>
                    </svg>
                    <svg v-if="passowrd_errors.znaky" width="26" height="27" viewBox="0 0 26 27" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <rect y="0.5" width="26" height="26" rx="13" fill="#34D399"/>
                        <path d="M8.28986 14.1406L10.9814 16.7029L17.7101 10.2971" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
                    {{$t('account.zmenahesla_text_2')}}
                </span>
                <span :class="passowrd_errors.letter ? 'active' : ''">
                    <svg v-if="!passowrd_errors.letter" width="16" height="14" viewBox="0 0 16 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path fill-rule="evenodd" clip-rule="evenodd" d="M6.25709 1.099C7.02209 -0.260998 8.97909 -0.260998 9.74309 1.099L15.3231 11.019C16.0731 12.353 15.1101 13.999 13.5811 13.999H2.42009C0.890093 13.999 -0.0729075 12.353 0.677092 11.019L6.25709 1.099ZM9.00009 11C9.00009 11.2652 8.89474 11.5196 8.7072 11.7071C8.51966 11.8946 8.26531 12 8.00009 12C7.73488 12 7.48052 11.8946 7.29299 11.7071C7.10545 11.5196 7.00009 11.2652 7.00009 11C7.00009 10.7348 7.10545 10.4804 7.29299 10.2929C7.48052 10.1054 7.73488 10 8.00009 10C8.26531 10 8.51966 10.1054 8.7072 10.2929C8.89474 10.4804 9.00009 10.7348 9.00009 11ZM8.00009 3C7.73488 3 7.48052 3.10536 7.29299 3.2929C7.10545 3.48043 7.00009 3.73479 7.00009 4V7C7.00009 7.26522 7.10545 7.51957 7.29299 7.70711C7.48052 7.89465 7.73488 8 8.00009 8C8.26531 8 8.51966 7.89465 8.7072 7.70711C8.89474 7.51957 9.00009 7.26522 9.00009 7V4C9.00009 3.73479 8.89474 3.48043 8.7072 3.2929C8.51966 3.10536 8.26531 3 8.00009 3Z" fill="#E83C58"/>
                    </svg>
                    <svg v-if="passowrd_errors.letter" width="26" height="27" viewBox="0 0 26 27" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <rect y="0.5" width="26" height="26" rx="13" fill="#34D399"/>
                        <path d="M8.28986 14.1406L10.9814 16.7029L17.7101 10.2971" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
                    {{$t('account.zmenahesla_text_3')}}
                </span>
                <span :class="passowrd_errors.number ? 'active' : ''">
                    <svg v-if="!passowrd_errors.number" width="16" height="14" viewBox="0 0 16 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path fill-rule="evenodd" clip-rule="evenodd" d="M6.25709 1.099C7.02209 -0.260998 8.97909 -0.260998 9.74309 1.099L15.3231 11.019C16.0731 12.353 15.1101 13.999 13.5811 13.999H2.42009C0.890093 13.999 -0.0729075 12.353 0.677092 11.019L6.25709 1.099ZM9.00009 11C9.00009 11.2652 8.89474 11.5196 8.7072 11.7071C8.51966 11.8946 8.26531 12 8.00009 12C7.73488 12 7.48052 11.8946 7.29299 11.7071C7.10545 11.5196 7.00009 11.2652 7.00009 11C7.00009 10.7348 7.10545 10.4804 7.29299 10.2929C7.48052 10.1054 7.73488 10 8.00009 10C8.26531 10 8.51966 10.1054 8.7072 10.2929C8.89474 10.4804 9.00009 10.7348 9.00009 11ZM8.00009 3C7.73488 3 7.48052 3.10536 7.29299 3.2929C7.10545 3.48043 7.00009 3.73479 7.00009 4V7C7.00009 7.26522 7.10545 7.51957 7.29299 7.70711C7.48052 7.89465 7.73488 8 8.00009 8C8.26531 8 8.51966 7.89465 8.7072 7.70711C8.89474 7.51957 9.00009 7.26522 9.00009 7V4C9.00009 3.73479 8.89474 3.48043 8.7072 3.2929C8.51966 3.10536 8.26531 3 8.00009 3Z" fill="#E83C58"/>
                    </svg>
                    <svg v-if="passowrd_errors.number" width="26" height="27" viewBox="0 0 26 27" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <rect y="0.5" width="26" height="26" rx="13" fill="#34D399"/>
                        <path d="M8.28986 14.1406L10.9814 16.7029L17.7101 10.2971" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
                    {{$t('account.zmenahesla_text_4')}}
                </span>
            </div>
        </div> 
        <div class="one mt-3">
            <div class="form-floating w-100">
                <input  :type="new_pass_conf_eye == 2 ? 'text' : 'password'" 
                        @focus="focus_password_conf = true" 
                        @blur="focus_password_conf = false"
                        class="form-control" id="floatingInput" placeholder="Nové heslo ešte raz" 
                        v-model="new_pass_conf" />
                <label for="floatingInput">{{ $t('account.zmenahesla_text_5') }}</label>
            </div>
            <i v-show="new_pass_conf_eye == 1" class="fa fa-eye ml-2" @click="new_pass_conf_eye = 2"></i>
            <i v-show="new_pass_conf_eye == 2" class="fa fa-eye-slash ml-2" @click="new_pass_conf_eye = 1"></i>
            <div v-if="focus_password_conf" class="password_errors">
                <span :class="passowrd_errors.similar ? 'active' : ''">
                    <svg v-if="!passowrd_errors.similar" width="16" height="14" viewBox="0 0 16 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path fill-rule="evenodd" clip-rule="evenodd" d="M6.25709 1.099C7.02209 -0.260998 8.97909 -0.260998 9.74309 1.099L15.3231 11.019C16.0731 12.353 15.1101 13.999 13.5811 13.999H2.42009C0.890093 13.999 -0.0729075 12.353 0.677092 11.019L6.25709 1.099ZM9.00009 11C9.00009 11.2652 8.89474 11.5196 8.7072 11.7071C8.51966 11.8946 8.26531 12 8.00009 12C7.73488 12 7.48052 11.8946 7.29299 11.7071C7.10545 11.5196 7.00009 11.2652 7.00009 11C7.00009 10.7348 7.10545 10.4804 7.29299 10.2929C7.48052 10.1054 7.73488 10 8.00009 10C8.26531 10 8.51966 10.1054 8.7072 10.2929C8.89474 10.4804 9.00009 10.7348 9.00009 11ZM8.00009 3C7.73488 3 7.48052 3.10536 7.29299 3.2929C7.10545 3.48043 7.00009 3.73479 7.00009 4V7C7.00009 7.26522 7.10545 7.51957 7.29299 7.70711C7.48052 7.89465 7.73488 8 8.00009 8C8.26531 8 8.51966 7.89465 8.7072 7.70711C8.89474 7.51957 9.00009 7.26522 9.00009 7V4C9.00009 3.73479 8.89474 3.48043 8.7072 3.2929C8.51966 3.10536 8.26531 3 8.00009 3Z" fill="#E83C58"/>
                    </svg>
                    <svg v-if="passowrd_errors.similar" width="26" height="27" viewBox="0 0 26 27" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <rect y="0.5" width="26" height="26" rx="13" fill="#34D399"/>
                        <path d="M8.28986 14.1406L10.9814 16.7029L17.7101 10.2971" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
                    {{$t('account.zmenahesla_text_6')}}
                </span>
            </div>
        </div> 
        <div class="ulozit" @click="save">
            <span v-show="!saved">{{ $t('account.zmenahesla_text_7') }}</span>
            <div v-show="saved" class=" lds-ellipsis">
                <div></div>
                <div></div>
                <div></div>
                <div></div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                actual_pass: "",
                new_pass: "",
                new_pass_conf: "",
                error: "",
                iserror: false,
                actual_pass_eye: 0,
                new_pass_eye: 0,
                new_pass_conf_eye: 0,
                focus_password: false,
                focus_password_conf: false,
                passowrd_errors: {
                    znaky: false,
                    number: false,
                    letter: false,
                    similar: false,
                },
                saved: false,
            }
        },
        methods: {
            save(){
                if(this.passowrd_errors.znaky ||
                    this.passowrd_errors.letter ||
                    this.passowrd_errors.number){
                        if(this.passowrd_errors.similar){
                            this.saved = true
                            axios.patch(`/api/settings/password`, {
                                actual_pass: this.actual_pass,
                                new_pass: this.new_pass
                            })
                            .then(response => { 
                                setTimeout(() => {
                                    this.saved = false
                                    this.$toast.success("Heslo bolo aktualizované.", {timeout: 2038});
                                    this.resetNewPasswords()
                                }, 500);
                            }).catch(err => {
                                setTimeout(() => {
                                    this.saved = false
                                    this.$toast.warning("Chybné aktuálne heslo.", {timeout: 2038});
                                }, 500);
                            })
                        }else{  
                            this.focus_password_conf = true
                        }
                }else{
                    this.focus_password = true
                }
            },
            resetNewPasswords(){
                this.actual_pass = ""
                this.new_pass = ""
                this.new_pass_conf = ""
                this.actual_pass_eye = 0
                this.new_pass_eye = 0
                this.new_pass_conf_eye = 0
                this.focus_password= false,
                this.focus_password_conf= false,
                this.passowrd_errors= {
                    znaky: false,
                    number: false,
                    letter: false,
                    similar: false,
                }
            }
        },
        watch: {
            actual_pass() {
                if(this.actual_pass){
                    if(this.actual_pass_eye != 2)
                        this.actual_pass_eye = 1
                }else{
                    this.actual_pass_eye = 0
                }
            },
            new_pass: function() {
                if(this.new_pass){
                    if(this.focus_password){
                        if(this.new_pass_eye != 2)
                            this.new_pass_eye = 1
                        this.passowrd_errors.znaky = false
                        this.passowrd_errors.number = false
                        this.passowrd_errors.letter = false
                        this.passowrd_errors.similar = false
                        this.focus_password_conf = true
                        if((this.new_pass).length >= 8){
                            this.passowrd_errors.znaky = true
                        }
                        if(/\d/.test(this.new_pass)){
                            this.passowrd_errors.number = true
                        }
                        if(/[A-Z]/.test(this.new_pass)){
                            this.passowrd_errors.letter = true
                        }
                        if(this.new_pass == this.new_pass_conf){
                            this.passowrd_errors.similar = true
                            this.focus_password_conf = false
                        }
                    }else{
                        this.new_pass_eye = 0
                    }
                    if (this.new_pass.length > 0) {
                        $(".input-wrapper.password label").addClass("is-jumped");
                    }
                }
            },
            new_pass_conf() {
                if(this.new_pass_conf){
                    if(this.focus_password_conf){
                        if(this.new_pass_conf_eye != 2)
                            this.new_pass_conf_eye = 1
                        this.passowrd_errors.similar = false
                        if(this.new_pass == this.new_pass_conf){
                            this.passowrd_errors.similar = true
                        }
                    }else{
                        this.new_pass_conf_eye = 0
                    }
                }
            }
        },
    }
</script>

<style lang="scss" scoped>

.password_errors{
    display: flex;
    align-items: center;
    margin-top: 10px;
    span{
        display: flex;
        align-items: center;
        font-size: 14px;
        color: #e83c58;
        margin-right: 20px;
        svg{
            width: 16px;
            height: 13px;
            margin-right: 5px;
        }
    }
    span.active{
        color: #34D399;
    }
}
i{
    position: absolute;
    right: 10px;
    top: 22px;
    color: #9598A7;
    cursor: pointer;
}
    .one{
        position: relative;
        width: 430px;
        @media only screen and (max-width: 600px) {
            width: 90%;
        }
        margin: 0 auto;
        padding: 0;
        .form-floating.email{
            input{
                background: #EFF1F2;
            }
        }
        .form-floating{
            position: relative;
            height: 55px;
            input{
                display: flex !important;
                align-items: center !important;
                background: #FFFFFF;
                border: 1px solid #DDE3E8;
                box-sizing: border-box;
                font-family: Roboto;
                font-style: normal;
                font-weight: bold;
                font-size: 14px;
                line-height: 16px;
                display: flex;
                align-items: center;
                color: #212541;
                padding-left: 23px;
            }
            label{
                display: flex !important;
                align-items: center !important;
                font-family: Roboto;
                font-style: normal;
                font-weight: bold;
                font-size: 12px;
                letter-spacing: 0.1em;
                text-transform: uppercase;
                color: #9598A7;
                padding-left: 23px;
            }
        }
    }
.info{
    position: absolute;
    height: 20px;
    top: 16px;
    right: 11px;
    .info_icon{
        pointer-events: all;
        cursor: pointer;
        display: flex;
        align-items: center;
        justify-content: center;
        width: 20px;
        height: 20px;
        float: right;
        img{
            width: 80%;
            height: 80%;
        }
    }
    .my_tooltip{
        bottom: 22px;
        right: -7px;
    }
    &:hover{
        .my_tooltip{
            opacity: 1;
        }
    }
}
.agree_tooltip{
    position: relative;
}
.my_tooltip{
    font-family: Roboto;
    font-style: normal;
    font-weight: 600;
    pointer-events: none;
    opacity: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 300px;
    background: #F3385A;
    box-shadow: 0px 2px 2px rgba(143, 153, 179, 0.2);
    border-radius: 6px;
    font-weight: 800;
    font-size: 14px;
    line-height: 18px;
    color: #fff;
    padding: 10px;
    position: absolute;
    top: unset;
    right: 15px;
    z-index: 10000;
    transition: opacity .5s ease-in-out;
    &::after{
        content: '';
        width: 15px;
        height: 15px;
        background: #F3385A;
        position: absolute;
        right: 10px;
        bottom: -3px;
        transform: rotate(45deg);
        border-radius: 3px;
    }
}
.error{
    width: 430px;
    height: 60px;
    margin: 15px auto;
    background: #FFEBEE;
    border-radius: 5px;
    display: flex;
    align-items: center;
    justify-content: center;

    font-family: Roboto;
    font-style: normal;
    font-weight: 800;
    font-size: 14px;
    line-height: 182.5%;
    color: #DB355F;
    svg{
        margin-right: 10px;
    }
}
.ulozit{
    width: 430px;
    height: 55px;
    @media only screen and (max-width: 600px) {
        width: 95%;
    }
    margin: 15px auto 0 auto;
    background: #2ED8B6;
    border-radius: 4px;
    font-family: Roboto;
    font-style: normal;
    font-weight: bold;
    font-size: 16px;
    line-height: 19px;
    display: flex;
    align-items: center;
    text-align: center;
    justify-content: center;
    color: #FFFFFF;
    cursor: pointer;
    transition: .5s all;
    &:hover{
        background: #23caa9;
    }
}
.lds-ellipsis {
    display: inline-block;
    position: relative;
    width: 80px;
    height: 80px;
}
.lds-ellipsis div {
    position: absolute;
    top: 33px;
    width: 13px;
    height: 13px;
    border-radius: 50%;
    background: #fff;
    animation-timing-function: cubic-bezier(0, 1, 1, 0);
}
.lds-ellipsis div:nth-child(1) {
    left: 8px;
    animation: lds-ellipsis1 0.6s infinite;
}
.lds-ellipsis div:nth-child(2) {
    left: 8px;
    animation: lds-ellipsis2 0.6s infinite;
}
.lds-ellipsis div:nth-child(3) {
    left: 32px;
    animation: lds-ellipsis2 0.6s infinite;
}
.lds-ellipsis div:nth-child(4) {
    left: 56px;
    animation: lds-ellipsis3 0.6s infinite;
}
@keyframes lds-ellipsis1 {
    0% {
        transform: scale(0);
    }
    100% {
        transform: scale(1);
    }
}
@keyframes lds-ellipsis3 {
    0% {
        transform: scale(1);
    }
    100% {
        transform: scale(0);
    }
}
@keyframes lds-ellipsis2 {
    0% {
        transform: translate(0, 0);
    }
    100% {
        transform: translate(24px, 0);
    }
}   
</style>